import React from 'react';
import { UIMyChallenges } from 'types';
import ChallengeCard from './ChallengeCard';

import { useNavigate } from 'react-router-dom';
import { BiChevronRight } from 'react-icons/bi';

interface Props {
	challenges: UIMyChallenges[];
	fromDashboard?: boolean;
}

const ChallengesContainer = ({ challenges, fromDashboard }: Props) => {
	const navigate = useNavigate();

	return (
		<div>
			<div
				className={
					fromDashboard
						? 'flex items-center justify-between gap-[4px]'
						: 'my-[16px] mt-[10px] border-b-[1px] dark:border-[#555770] border-[#C7C9D9] pb-[16px]'
				}
			>
				<h5 className="text-[24px] font-[700] leading-[30px] text-[#1F3343] dark:text-[#CDF] font-inter ">
					Challenges
				</h5>
				{fromDashboard && (
					<div className="flex items-center gap-[4px] cursor-pointer ">
						<p
							onClick={() => {
								navigate('/challenges');
							}}
							className="text-[#1F3343] dark:text-[#CDF] text-[12px] font-[400] leading-[16px] font-inter "
						>
							See all
						</p>
						<BiChevronRight className="text-[#1F3343] dark:text-[#CDF]" />
					</div>
				)}
			</div>
			<div
				className={`grid ${fromDashboard ? 'md:grid-cols-3' : 'md:grid-cols-3 lg:grid-cols-4'}  gap-[24px] mt-[20px]`}
			>
				{challenges.map((challenge, index) => (
					<div key={challenge.title + index} className="">
						<ChallengeCard challenge={challenge} />
					</div>
				))}
			</div>
		</div>
	);
};

export default ChallengesContainer;
